import React from 'react'

// Props
// direction : left | right
// color :string
// className:string

const ArrowIcon = ({
  color = '#ffffff',
  direction = 'left',
  className = '',
}) => {
  return (
    <div
      style={{ transform: direction === 'right' ? 'rotate(180deg)' : 'none' }}
      className={className}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.40864 3.44425C9.3937 3.42924 8.93562 3.31442 8.39077 3.18919C7.84585 3.06396 7.39413 2.98064 7.38687 3.0039C7.37967 3.02722 7.32328 3.40542 7.26164 3.84438C7.13779 4.72587 6.83794 5.75507 6.51753 6.39873C5.51882 8.40475 3.72695 9.73302 1.55365 10.0783L1.00023 10.1662L1.00023 11.0523L1.00023 11.9386L1.50183 12.0227C4.78814 12.5741 6.93065 15.0313 7.33145 18.7085C7.3576 18.9486 7.38887 19.145 7.40091 19.145C7.51175 19.145 9.34825 18.7024 9.38298 18.6674C9.40809 18.642 9.38941 18.4169 9.3414 18.1672C8.80997 15.4024 7.28835 13.1525 5.31375 12.2118L4.8401 11.9861L14.5802 11.9685L20.7393 11.9573L20.7393 10.1638L14.5644 10.1526L4.84722 10.1348L5.44521 9.83185C6.99651 9.04591 8.22472 7.5042 8.948 5.43484C9.15411 4.8453 9.4651 3.50124 9.40864 3.44425Z"
          fill={color}
        />
      </svg>
    </div>
  )
}

export default ArrowIcon
